import { parse, format, parseISO, formatISO } from "date-fns";

const AVAILABILITY_REQUEST_FORMAT_STRING = "yyyyMMdd";
const FACILITY_FORMAT_STRING = "yyyy-MM-dd";

function parseFacilityDate(date) {
  return parse(date, FACILITY_FORMAT_STRING, new Date());
}

function formatFacilityDate(date, formatString = "yyyy-MM-dd") {
  return format(parseFacilityDate(date), formatString);
}

function parseAvailabilityRequestDate(date) {
  return parse(date.toString(), AVAILABILITY_REQUEST_FORMAT_STRING, new Date());
}

function formatAvailabilityRequestDate(date, formatString = "yyyy-MM-dd") {
  return format(parseAvailabilityRequestDate(date), formatString);
}

function formatToAvailabilityRequestDate(date) {
  return parseInt(format(date, AVAILABILITY_REQUEST_FORMAT_STRING, new Date()));
}

function toUnixTimestamp(date) {
  return Math.floor(date.getTime() / 1000);
}

function transformDateString(
  dateString,
  transformer,
  formatString = "yyyy-MM-dd",
) {
  return format(
    transformer(parse(dateString, formatString, new Date())),
    formatString,
  );
}

function transformISODateString(dateString, transformer) {
  return formatISO(transformer(parseISO(dateString)));
}

export {
  AVAILABILITY_REQUEST_FORMAT_STRING,
  FACILITY_FORMAT_STRING,
  parseFacilityDate,
  formatFacilityDate,
  parseAvailabilityRequestDate,
  formatAvailabilityRequestDate,
  formatToAvailabilityRequestDate,
  toUnixTimestamp,
  transformDateString,
  transformISODateString,
};
